import React, { Component, Fragment } from 'react'
import Footer from '../../components/layout/Footer';

import '../../assets/style/itemStyle/common.scss';

export default class AffiliateAgreement extends Component {
  render() {
    return (
      <>
      <div className="term-of-use-content">
        <br />
        <p><b>Last Updated: Nov 7, 2022</b></p><br />
        
        <p className="title">1.  CONTRACTOR SERVICES</p> <br />

        1.1.  Description of Services. During the Term (as defined below), Contractor shall serve as a Dealer 
        for the Airacer platform (the “Services”). Contractor may perform Services remotely, or at any 
        such location as may be agreed upon by the Parties. Contractor Services include, but are not 
        limited to, the following:<br />
        
        (a)  Provide customer assistance with booking processing and cancellations, including handling 
          and fee calculations, if applicable;<br/>
        (b) Answer customer questions about any Company loyalty programs; and<br/>
        (c)  Engage in any other related tasks that Company may require from time to time.<br />
        
        1.2.  Performance of Services. The manner in which the Services are to be performed and the specific 
        hours to be worked shall be determined by Contractor. Contractor shall perform Services from 
        different and remote locations as may be mutually agreed upon by both Parties. Services are to be 
        personally performed by Contractor, and may not be delegated, assigned or subcontracted to any 
        other person for any reason without Company’s prior written consent.
        <br /><br />

        <span className="title">2.  TERM AND TERMINATION. </span>

        The term of this Agreement (“Term”) shall commence on the 
        Effective Date, and shall continue until terminated as provided in this Agreement. This Agreement is 
        terminable by either Party at any time, for any reason effective upon fourteen (14) days-notice to the 
        other Party. Upon termination, any obligation Company may otherwise have under this Agreement 
        shall cease immediately. Sections 4, 5, 6, 7, 9, 10, 11 and 12 shall continue and survive this Agreement.
        <br /><br />
        
        <p className="title">3.  COMPENSATION</p><br />
        
        3.1.Commission.Contractor shall receive an eight percent (8%) commission for each transaction of 
        flight experience and flight training packages that are directly procured by Contractor through 
        the Airacer Platform. Contractor shall also receive a four percent (4%) commission for each 
        transaction of U.S. domestic and international charter flights that are led by Contractor.<br /><br />

        3.2.  Expenses. Any expenses reasonably incurred on behalf of the Company by Contractor during the 
        term of this Agreement, must be approved by the Company in advance. Company may reimburse 
        Contractor upon presentation of appropriate receipts for any such expenses, at Company’s sole discretion.
        <br /><br />
        
        <p className="title">4.  CONFIDENTIALITY</p><br />
        4.1. Confidential  Information.  Contractor  understands  that 	“Confidential  Information”  means
        information that the Company, together with its affiliates and subsidiaries, (i) has or will develop, 
        acquire, create, compile, discover or own, that has value in or to the Company’s business which is 
        not generally known to the public; (ii) information which the Company wishes to maintain as 
        confidential; (iii) information disclosed by the Company to Contractor, and information developed 
        or learned by Contractor during the performance of the Services or (iii) all information of which 
        the unauthorized disclosure could be detrimental to the interests of the Company, whether or not 
        such information is identified as Confidential Information. Confidential Information shall include, 
        without limitation, any and all non-public information that relates to the Company’s actual or 
        anticipated business and/or products, research and development technical data, or know-how, 
        information  regarding the Company’s  products or services, developments, ideas, processes, 
        technology, marketing, and other business information disclosed by the Company either directly or 
        indirectly. Confidential Information shall not include any such information which Contractor can 
        establish (i) was publicly known or made generally available prior to the time of disclosure by the 
        Company to Contractor; (ii) becomes publicly known or made generally available after disclosure 
        by the Company to Contractor through no wrongful action or omission by Contractor; or (iii) is in 
        Contractor’s rightful possession, without confidentiality obligations, at the time of disclosure by 
        the Company as shown by Contractor’s then-contemporaneous written records.<br /><br />

        4.2. Nonuse and Nondisclosure. Contractor shall, during the term of this Agreement, and after the expiration  or termination  thereof,  hold  in  the strictest  confidence,  and  take  all  reasonable 
        precautions to prevent any unauthorized use or disclosure of Confidential Information, and 
        Contractor shall not (i) use Confidential Information for any purpose whatsoever other than for the 
        benefit of the Company  for the performance of the Services, or (ii) disclose Confidential 
        Information to any third party without the prior written authorization of the Company. Contractor 
        shall obtain no title to any Confidential Information. Contractor’s obligations under this Section 
        shall continue after termination of this Agreement.
        <br /><br />

        <span className="title">5.  WORK PRODUCT OWNERSHIP.</span> 
        All electronic files, data, media, inventions and/or other work 
        product, including any adaptations thereof (collectively, “Work Product”) developed by Contractor on 
        Company’s behalf, or developed using Company’s Confidential Information, are and shall be the sole 
        and exclusive property of Company. Contractor agrees that the Work Product is specially ordered or 
        commissioned by Company and constitutes works made for hire authored by Company under 17 U.S.C. 
        §101. To the extent that any of the Work Product is deemed not to be a work made for hire, Contractor 
        hereby conveys, grants, and assigns to Company all right, title and interest worldwide in and to such 
        Work Product, all physical elements thereof, all intangible rights thereto, and all contractual rights and obligations relating thereto, for all uses and purposes whether now known or hereafter created.
        <br /><br />
        
        <span className="title"> 6.  RETURN OF MATERIALS.</span> 
        All materials provided by Company for the performance of the 
        Services, including without limitation documents, technology, data, equipment, computer media, 
        electronic files and lists, (together the “Materials”), which are furnished to Contractor by Company or 
        which are developed in the process of performing the Services, or embody or relate to the Services, are 
        the property of Company, and shall be returned by Contractor to Company promptly at Company's 
        request together with any copies thereof, and in any event promptly upon expiration or termination of 
        this Agreement for any reason.
        <br /><br />
        
        <p className="title">7.  RESTRICTIVE COVENANTS</p> <br />
        7.1.  Covenant not to Compete. Contractor agrees that, during the Term of this Agreement, Contractor 
        shall not own any entity, or serve as an advisor, consultant, employee or be in any way associated 
        with any company, which engages in the same or similar business as Company or competes with 
        the business of Company.<br /><br />

        7.2.  Non-Solicitation. During the term of this Agreement, and for a period of one (1) year immediately 
        thereafter, Contractor shall not contact, or cause to be contacted, directly or indirectly, or engage 
        in any form of oral, verbal, written, recorded, transcribed, or electronic communication with any 
        customer of the Company in order to: (i) conduct business that is competitive or similar to that of 
        the  Company,  (ii)  attempt  to,  or to  disadvantage,  disrupt  or interfere  with  any  business 
        relationships, contractual or otherwise, between the Company and any of its customers or potential 
        customers, and (iii) to induce or attempt to induce, directly or indirectly, any of Company’s 
        customers to modify or terminate such customer’s business relationship with the Company. For 
        the purposes of this Agreement, “Customer” shall mean all persons or entities that have used or 
        inquired of the Company’s services.<br /><br />

        7.3.  Non-Circumvention. Contractor hereby agrees that, for a period of one (1) year after the 
        termination or expiration of this Agreement, Contractor will not: (i) enter into any agreement, 
        transaction or arrangement or (ii) solicit, take away, or attempt to call on, any customer of 
        Company whom Contractor became acquainted, directly or indirectly, during the term of this 
        Agreement, as the result of Contractor’s performance of the Services for Company for the purpose 
        of circumventing and preventing Company from realizing or recognizing a profit, fees, or 
        otherwise. If such circumvention shall occur, Company shall be entitled to any commissions or 
        fees due pursuant to this Agreement or relating to such transaction.<br /><br />

        7.4.  Non-Disparagement. Contractor will not at any time during the term of this Agreement, or after 
        the expiration or termination thereof, directly or indirectly (i) disparage, libel, defame, ridicule or 
        make negative comments regarding, or encourage or induce others to disparage, libel, defame, 
        ridicule or make negative comments regarding, the Company, or any of the Company's employees, 
        directors, Contractors or agents, or the Company's products, services, business plans or methods; 
        or (ii) engage in any conduct or encourage or induce any other person to engage in any conduct 
        that is in any way injurious or potentially injurious to the reputation or interests of the Company 
        or any of the Company's, employees, directors, Contractors or agents.<br /><br />

        7.5.  Remedy for Breach. Contractor acknowledges that the provisions of this Section 4 are reasonable 
        and necessary for the protection of the Company and that the Company will be irrevocably 
        damaged if such covenants are not specifically enforced. Accordingly, the Contractor agrees that, 
        in addition to any other relief to which the Company may be entitled, the Company shall be entitled 
        to seek and obtain injunctive relief from a court of competent jurisdiction for the purposes of 
        restraining the Contractor from any actual or threatened breach of such covenants.
        <br /><br />
        
        <span className="title">8.  REPRESENTATIONS AND WARRANTIES.</span>  
        Each Party to this Agreement represents and warrants 
        to the other Party that they (a) have full power, authority and legal right to execute and perform this 
        Agreement; (b) this Agreement constitutes the legal, valid and binding obligations of such Party in 
        accordance with its terms; and (c) shall act in good faith to give effect to the intent of this Agreement and to take such other action as may be necessary or convenient to consummate the purpose and subject matter of this Agreement.<br /><br />

        <span className="title"> 9.  INDEPENDENT CONTRACTOR.</span> Contractor is an independent contractor and nothing in this 
        Agreement or in the course of performance of this Agreement shall be interpreted to create an 
        employment relationship between Company and Contractor. Contractor has no authority to bind the 
        Company or act as an agent of the Company. It is also agreed that Contractor shall have no right to 
        make any commitments on behalf of the Company without the express written consent of the Company.<br /><br />

        <span className="title">10. INDEMNIFICATION.</span> Contractor hereby agrees to indemnify and hold harmless Company, its 
        officers, directors, agents and contractors, against any losses, claims, lawsuits, damages or liabilities arising directly or indirectly out of the acts or omissions of Contractor, including, but not limited to all damages, attorney’s fees, and other liabilities to which Company may become subject, as a result of Contractor’s act or omissions or any other claims brought associated with this Agreement.
        <br /><br />
        
        <span className="title">11. ARBITRATION.</span> 

        Contractor and the Company agree that any dispute or controversy in connection 
        with this Agreement, including its interpretation, will be conclusively settled by submission to 
        arbitration (the “Arbitration”) in accordance with the rules of arbitration of the American Arbitration 
        Act as amended from time to time. The Arbitration will be conducted in the State of New York before 
        a single arbitrator mutually agreeable to the parties (the “Arbitrator”). The initial costs of the Arbitrator <br />
        
        will be born equally by the parties. The Arbitrator shall have the power to award costs in his or her 
        discretion in making his or her award or decision. Nothing in this clause prohibits the Company from 
        seeking injunctive relief in New York courts against the Contractor as referenced in this Agreement. 
        The decision of the Arbitrator shall be final and binding and without any right of appeal. BOTH 
        PARTIES ACKNOWLEDGE AND AGREE THAT BY AGREEING TO ARBITRATE, THEY ARE 
        IRREVOCABLY AND UNCONDITIONALLY WAIVING ANY RIGHT TO BRING AN ACTION 
        AGAINST THE OTHER IN A COURT OF LAW, AND ARE WAIVING THE RIGHT TO HAVE 
        CLAIMS AND DAMAGES, IF ANY, DETERMINED BY A JURY.<br /><br />

        <p className="title">12.  GENERAL PROVISIONS</p><br /><br />
        
        12.1.  Entire Agreement. This Agreement contains the entire agreement of the parties, and there are 
        no other promises or conditions in any other agreement whether oral or written concerning the
        subject matter of this Agreement. This Agreement supersedes any prior written or oral agreements between the Parties.<br /><br />

        12.2.  Severability. If any provision of this Agreement will be held to be invalid or unenforceable for 
        any reason, the remaining provisions will continue to be valid and enforceable. If a court finds 
        that any provision of this Agreement is invalid or unenforceable, but that by limiting such 
        provision it would become valid and enforceable, then such provision will be deemed to be 
        written, construed, and enforced as so limited.<br /><br />

        12.3.  Notices. Any notice required or permitted to be given under this Agreement shall be sufficient if 
        in writing and if sent by personal delivery, by a nationally recognized overnight courier (provided 
        a written acknowledgement of receipt is obtained) or by First Class or Certified Mail to the 
        addresses provided by the Parties, or to such other address as such party shall notify the other.<br /><br />

        12.4.  Waiver. The waiver by any party hereto of a breach of any provision of this Agreement shall not 
        operate or be construed as a waiver of any subsequent breach.<br /><br />

        12.5.  No Third-Party Beneficiaries. Except as otherwise provided, nothing in this Agreement shall 
        provide any benefit to any third party or entitle any third party to any claim, cause of action, 
        remedy, or right of any kind.<br /><br />
        
        12.6.  Successors and Assigns. This Agreement may not be assigned without the prior written consent 
        of the Parties. Rights and obligations created by this Agreement shall be binding upon and inure 
        to the benefit of the Parties, their successors and assigns.<br /><br />

        12.7.  Headings. The section and other headings contained in this Agreement are for reference purposes 
        only and shall not affect the meaning or interpretations of this Agreement.<br /><br />
        
        12.8.  Amendments. This Agreement may be modified or amended in writing, if the writing is signed 
        by the party obligated under the amendment.<br /><br />
        
        12.9.  Governing Law; Jurisdiction. This Agreement will be governed by and construed in accordance 
        with the laws of the State of New York excluding its body of law controlling conflict of laws. Any 
        legal action or proceeding arising under this Agreement will be brought exclusively in the courts 
        located in New York and the parties irrevocably consent to the personal jurisdiction and venue 
        therein. <br /><br />

        IN WITNESS WHEREOF, the Parties have executed this Agreement as of the date above written. 
        <br /><br />

        <b>CONTACT US</b><br /><br />
        We welcome your questions or comments regarding these Terms:
        <br /><br />
        <b>Airacer Inc.</b><br /><br />

        <b>By Email:</b><br />
        <a className="email" href="mailto:info@airacer.com">info@airacer.com</a><br /><br />
       
        <b>By Mail:</b><br />
        Airacer Inc.<br />
        28-07 Jackson Ave<br />
        Long Island City, NY 11101<br /><br />
      </div>
      <Footer />
    </>
    )
  }
}
